import './style.scss';
import './event-detail-block.tpl.php';
import './autism.svg';
import 'script-loader!bootstrap-sass/assets/javascripts/bootstrap/tooltip';

jQuery(document).ready(function() {
  jQuery('.event-detail-block [data-toggle="tooltip"]').tooltip();
});
